import { motion } from 'framer-motion';
import React from 'react';
import './CircleRadius.module.scss';
import Item from './Item';

const getAngle = (ring: 'inner' | 'outer', i: number) =>
  ring === 'inner'
    ? 0.375 * (i + 1)
    : i === 0
    ? // right top
      1.85
    : i === 1
    ? // right center
      2
    : i === 2
    ? // right bottom
      0.15
    : i === 3
    ? // left bottom
      0.85
    : i === 4
    ? // left center
      1
    : // left top
      1.15;

export default function CircleRadius({
  ring,
  skills,
  people,
}: {
  ring: 'inner' | 'outer';
  skills?: { skill: SkillEntity; size: 'big' | 'small' }[];
  people?: {
    person: PeopleEntity;
    calculatedValue: number;
  }[];
}) {
  const size = ring === 'inner' ? 460 : 1000;

  return (
    <motion.div
      styleName="wrapper "
      initial={{ scale: 0 }}
      exit={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ duration: 0.8, delay: ring === 'outer' ? 0.15 : 0 }}
    >
      {/* relative wrapper */}
      <div
        style={{
          width: size,
          height: size,
          position: 'relative',
        }}
      >
        {/* Helper circle */}
        <motion.div styleName="circle" />
        {/* Items */}
        {!!skills?.length &&
          skills.map((skill, i) => (
            <Item
              skill={skill}
              size={size}
              initial={getAngle(ring, i)}
              ring={ring}
              key={i}
            />
          ))}
        {!!people?.length &&
          people.map((person, i) => (
            <Item
              person={person.person}
              size={size}
              initial={getAngle(ring, i)}
              ring={ring}
              key={i}
            />
          ))}
      </div>
    </motion.div>
  );
}
